import React from 'react';
import { V2FormProvider } from '@abyss/web/ui/FormProvider';
import { Grid } from '@abyss/web/ui/Grid';
import { Box } from '@abyss/web/ui/Box';
import { Heading } from '@abyss/web/ui/Heading';
import { V2TextInput } from '@abyss/web/ui/TextInput';
import { GridBuilder } from '@src/components/global/GridBuilder';
import { ThemeGridController } from './ThemeGrid.Controller';

export const ThemeGrid = () => {
  const { form, gridProps } = ThemeGridController();

  return (
    <Box color="transparent" padding="$md" width="100%">
      <V2FormProvider state={form}>
        <Grid>
          <Grid.Col span={{ xs: '100%' }}>
            <Grid>
              <Grid.Col span={{ xs: 12, sm: 12 }}>
                <Heading display="h4" color="$primary1">
                  Filters
                </Heading>
              </Grid.Col>
              <Grid.Col span={{ xs: 12, sm: 12, md: 8 }}>
                <Grid>
                  <Grid.Col span={{ xs: 12, sm: 12, md: 4 }}>
                    <V2TextInput label="Name" model="name" isClearable />
                  </Grid.Col>
                </Grid>
              </Grid.Col>
            </Grid>
          </Grid.Col>
          <Grid.Col span={{ xs: '100%' }}>
            <GridBuilder props={gridProps} />
          </Grid.Col>
        </Grid>
      </V2FormProvider>
    </Box>
  );
};
